import React from "react";

const DetailField = ({ label, value }) => (
  <div className="pe-2">
    <label
      className="mb-1 d-block fw-normal"
      style={{ color: "#98A2B3", fontSize: "11px" }}
    >
      {label}
    </label>
    <div
      className="fw-bold"
      style={{ color: "#101828", fontSize: "13px", wordBreak: "break-word", lineHeight: "1.4" }}
    >
      {value || "-"}
    </div>
  </div>
);

export default DetailField;
